import { baseClient, API, authClient } from '../../utils/index';

export const createProduct = async (data) => {
	return baseClient().post(`${API}/products/add`, data);
};
